import { typeChecker } from './typeChecker';
import Moment from 'moment';


// 處理'2017-09-28 03:00:00'格式時間字串，去除時間只保留日期字串
// 傳入物件，並指定物件中要處理的 key 名稱陣列
// haveTime決定時間是否保留
// isRepublic決定年份是否轉成民國
export function dateFormatCutter(item, dateKeysToProcess, haveTime, isRepublic) {
  if (!item) {
    throw new Error('Missing parameter: first argument should be an object.');
  }

  if (typeChecker(item) !== 'Object') {
    throw new Error('TypeError: ' + item + ' should be an object.');
  }

  if (!dateKeysToProcess) {
    throw new Error('Missing parameter: second argument should be an array of strings.');
  }

  const newItem = {
    ...item
  }

  for (let i = dateKeysToProcess.length - 1, tempSpace; i >= 0; i--) {
    tempSpace = newItem[dateKeysToProcess[i]];

    if (
      tempSpace &&
      tempSpace !== '0000-00-00 00:00:00'
    ) {
      let newYear = Moment(tempSpace).format('YYYY');
      if (isRepublic) newYear = (Moment(tempSpace).format('YYYY') * 1) - 1911;

      if (!haveTime) {
        // 以'空格'定位
        newItem[dateKeysToProcess[i]] = !tempSpace ? '' : `${newYear}${Moment(tempSpace).format('-MM-DD')}`;
      } else {
        newItem[dateKeysToProcess[i]] = !tempSpace ? '' : `${newYear}${Moment(tempSpace).format('-MM-DD HH:mm')}`;
      }
    } else newItem[dateKeysToProcess[i]] = '';
  }

  return newItem;
}


// WEBPACK FOOTER //
// ./src/commonJS/formatters.js